module.exports = __webpack_public_path__ + "static/bounty-results-c5b9658ee650994873c60407b35de665.jpeg";